import { Toast } from 'primereact/toast';
import { Tooltip } from 'primereact/tooltip';
import React, { useState, useEffect, useRef } from 'react';
import apis from '../../api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Card } from 'primereact/card';
import { Message } from 'primereact/message';
import { Toolbar } from 'primereact/toolbar';
import { excelExport } from '../../services/excelExport.service';
import dateFormat from '../../services/DateFormat.service';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api'

const OccasionalMarking = () => {
    const [novelties, setNovelties] = useState([])
    const [calendarList, setCalendarList] = useState([])

    const [loadPage, setLoadPage] = useState(false);
    const [loading1, setLoading1] = useState(false)
    const [isOpenApprove, setIsOpenApprove] = useState(false)
    const [isOpenReject, setIsOpenReject] = useState(false)

    const headers = { Authorization: localStorage.getItem("token") }
    const client = localStorage.getItem('client')
    const entity = localStorage.getItem('entity')

    const [settlementDate, setSettlementDate] = useState("")
    const [calendar, setCalendar] = useState("")
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [occasional, setOccasional] = useState([])

    const [loadingExport, setLoadingExport] = useState(false);
    const [exportContent, setExportContent] = useState([])

    const toast = useRef(null);

    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(10);
    const [occasionalSelected, setOccasionalSelected] = useState([]);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    useEffect(() => {
        setSettlementDate("")
        setStartDate("")
        setEndDate("")
        setCalendar("")
        setOccasional([])
        setOccasionalSelected([])
        if(window.location.href.indexOf('/OccasionalMarking') !== -1){
            getMarkingOccasionalOccasionalList()
            getMarkingOccasional()
        }
        else{
            setNovelties([])
            setLoadPage(true)
        }
    }, [window.location.href])

    const hideModalApprove = () => {
        setSettlementDate("")
        setStartDate("")
        setEndDate("")
        setCalendar("")
        setOccasional([])
        setOccasionalSelected([])
        setIsOpenApprove(false)
    }

    const hideModalReject = () => {
        setSettlementDate("")
        setStartDate("")
        setEndDate("")
        setCalendar("")
        setOccasional([])
        setOccasionalSelected([])
        setIsOpenReject(false)
    }

    //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    //Limpiar e inicializar los filtros
    const clearFilter1 = () => {
        initFilters1();
    }

    const renderHeader1 = () => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm " onClick={clearFilter1} />
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search"> </InputIcon>
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm" />
                </IconField>
            </div>
        )
    }

    //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
    const header1 = renderHeader1();

    //Limpiar filtros de la tabla
    const initFilters1 = () => {
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NUMBER_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'JOB': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'CONTRACT_TYPE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'STATUS': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'START_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'END_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'RETIREMENT_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
        });
        setGlobalFilterValue1('');
    }

    //Nombre de las opciciones para los filtros
    const matchModes = [
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];
    
    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }

    //Retorna componente del paginador de la tabla y se puede configurar el numero de elementos por pagina
    const template2 = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
            { label: 5, value: 5 },
            { label: 10, value: 10 },
            { label: 20, value: 20 }
            ];

            return (
            <React.Fragment>
                <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por pagina: </span>
                <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
            </React.Fragment>
            );
        },
        'CurrentPageReport': (options) => {
            return (
            <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                {options.first} - {options.last} of {options.totalRecords}
            </span>
            )
        }
    };

    const getMarkingOccasionalOccasionalList = async () => {
        try{
            await apis.markingOccasionalList(entity, client, headers).then(res => { 
                setCalendarList(res.data.CALENDAR)
            })
        }
        catch(error){
            console.log(error)
        }
    }

    const getMarkingOccasional = async () => {
        setLoadPage(false)
        const option = window.location.href.indexOf('/HistoricOccasionalMarking') !== -1 ? '0' : '1'
        const startDate_ = startDate ? dateFormat(startDate) : 'NULL'
        const endDate_ = endDate ? dateFormat(endDate) : 'NULL'
        try{
            await apis.getMarkingOccasional(entity, client, option, startDate_, endDate_, headers).then(res => {
                let data = []
                let exportData = []
                res.data.NOV_OCCA_TRK.forEach(nov => {
                    const contract_ = nov.CONTRACT_ID.split('|')
                    const concept_ = nov.CONCEPT_ID.split('|')
                    const status_ = nov.STATUS.split('|')
                    const costCenter_ = nov.COST_CENTER_ID.split('|')
                    const calendar_ = nov.CALENDAR_ID ? nov.CALENDAR_ID.split('|') : ["", ""]
                    let newNov= {
                        ...nov,
                        CONTRACT_ID: contract_[0],
                        CONTRACT: contract_[1],
                        CONCEPT_ID: concept_[0],
                        CONCEPT: concept_[1],
                        STATUS: status_[0],
                        STATUS_DESC: status_[1],
                        COST_CENTER_ID: costCenter_[0],
                        COST_CENTER: costCenter_[1],
                        CALENDAR_ID: calendar_[0],
                        CALENDAR: calendar_[1]
                    }
                    let newExport = {
                        ID: nov.OCCASIONAL_ID,
                        'ID marcación': nov.SHIFT_MARKING_ID,
                        'Año': nov.YEAR,
                        'Semana': nov.WEEK,
                        Contrato: contract_[0],
                        Nombre: contract_[1],
                        'Concepto': concept_[0],
                        'Nombre concepto': concept_[1],
                        'Unidad': nov.UNIT,
                        'Fecha evento': nov.EVENT_DATE,
                        'Fecha pago': nov.SETTLEMENT_DATE,
                        'Calendario': calendar_[0],
                        'Nombre calendario': calendar_[1],
                        Comentarios: nov.COMMENTS,
                        'Estado': status_[1],
                        'Centro de costo contable': costCenter_[1],
                        'Código centro de costo contable': costCenter_[0],
                    }
                    console.log(newNov)
                    data.push(newNov)
                    exportData.push(newExport)
                    
                })
                console.log(data)
                setExportContent(exportData)
                setNovelties(data)
            })
        }
        catch(error){
            console.log(error)
        }
        finally{
            setLoadPage(true)
        }
    }

    const postMarkingOccasional = async (type) => {
        setLoading1(true)
        const occasional_ = occasional.map(occ => {return occ.OCCASIONAL_ID})
        try{
            const payload = {
                ENTITY: entity,
                CLIENT: client,
                OCCASIONAL: occasional_,
                ACTION: type,
                SETTLEMENT_DATE: settlementDate && dateFormat(settlementDate),
                ID_CALENDAR: calendar && calendar.ID_CALENDAR
            }
            await apis.postMarkingOccasional(payload, headers).then(res => {
                getMarkingOccasional()
                hideModalApprove()
                hideModalReject()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: res.data.MESSAGE});
            })
        }
        catch(err){
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
        finally{
            setLoading1(false)
        }
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div className='flex flex-row gap-1'>
                <Button icon="pi pi-check" className="p-button-warning p-button-sm text-xs" onClick={() => {setOccasional([rowData]); handleOccasionalSelection('APD')} }/>
                <Button icon="pi pi-times" className="p-button-danger p-button-sm text-xs" onClick={() => {setOccasional([rowData]); handleOccasionalSelection('REC')}}/>
            </div>
        )
    }


    const approveFooter = (
        <div>
            <Button onClick={() => { setLoading1(false); hideModalApprove() }}>Cancelar</Button>
            <Button label="Aprobar" className='p-button-success' loading={loading1} onClick={() => postMarkingOccasional('APD')} disabled={!calendar && !settlementDate}/>
        </div>
    );

    const approveHeader = (
        <div>
            <h3>Aprobar novedades marcación</h3>
        </div>
    )

    const rejectFooter = (
        <div>
            <Button onClick={() => { setLoading1(false); hideModalReject() }}>Cancelar</Button>
            <Button label="Rechazar" className='p-button-danger' loading={loading1} onClick={() => postMarkingOccasional('REC')} disabled={!calendar && !settlementDate}/>
        </div>
    );

    const rejectHeader = (
        <div>
            <h3>Rechazar novedades marcación</h3>
        </div>
    )

    const msgContent = (
        <div>
            <a style={{ fontWeight: 'bold', textDecoration: 'underline', color: '#3b82f6' }}>
            {process.env.REACT_APP_DISABLE_MSG}
            </a>
        </div>
    )

    const exportExcel = () => {
        const name = 'OcasionalesMarcacion' + (window.location.href.indexOf('/OccasionalMarking') !== -1 ? '' : 'Historico')
        try{
            excelExport(exportContent, name)
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Exportado con éxito" });
        }
        catch (err) {
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: "Error al exportar", sticky: true });
        }
        finally{
            setLoadingExport(false);
        }
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Calendar id="navigators" value={startDate} onChange={(e) => setStartDate(e.value)} locale="es" dateFormat="dd-mm-yy" showIcon placeholder="Fecha inicio" style={{width: '10.5rem'}}/>
                <Calendar id="navigators" value={endDate} onChange={(e) => setEndDate(e.value)} locale="es" dateFormat="dd-mm-yy" showIcon placeholder="Fecha fin" style={{width: '10.5rem'}}/>
            </React.Fragment>
        )
    }

    const rightToolbarTemplate = () => {
        return (
          <React.Fragment>
            {window.location.href.indexOf('/OccasionalMarking') !== -1 && <Button label="Aprobar" icon="pi pi-check" className="p-button-success p-button-sm" disabled={occasionalSelected.length === 0} onClick={() => handleOccasionalSelection('APD')}/>}
            {window.location.href.indexOf('/OccasionalMarking') !== -1 && <Button label="Rechazar" icon="pi pi-times" className="p-button-danger p-button-sm" disabled={occasionalSelected.length === 0} onClick={() => handleOccasionalSelection('REC')}/>}
          </React.Fragment>
        )
    }

    const leftToolbarTemplate2 = () => {
        return (
            <React.Fragment>
                <Button label="Consultar" icon="pi pi-search" className="p-button p-button-sm" onClick={getMarkingOccasional}/>
            </React.Fragment>
        )
    }

    const rightToolbarTemplate2 = () => {
        return (
          <React.Fragment>
            <Button label="Exportar" icon="pi pi-file-excel" tooltip='Exportar información de la tabla' loading={loadingExport} disabled={exportContent.length === 0}
                tooltipOptions={{ position: 'top' }} className="p-button-info mr-2 p-button-sm" onClick={() => { setLoadingExport(true); exportExcel() }} />
          </React.Fragment>
        )
    }

    const handleOccasionalSelection = (value) => {
        switch(value){
            case 'APD':
                setIsOpenApprove(true)
                break
            case 'REC':
                setIsOpenReject(true)
        }
    }

    return(
        <div className="flex flex-wrap align-items-center justify-content-center flex-column align-self-center">
            <Tooltip target=".info" className='indigo-tooltip ml-1' />
            <Toast ref={toast} style={{ backgroundColor: 'white' }} />
            <Dialog header={approveHeader} footer={approveFooter} visible={isOpenApprove}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalApprove}>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Fecha pago</label>
                    <Calendar id="navigators" value={settlementDate} onChange={(e) => setSettlementDate(e.value)} locale="es" dateFormat="dd-mm-yy" showIcon placeholder="Fecha pago" />
                </div>
                <div className='flex flex-column gap-1'>
                    <label htmlFor="label">Calendario</label>
                    <Dropdown filter showClear filterBy="DETAIL" optionLabel='DETAIL' placeholder="Calendario" value={calendar} options={calendarList} onChange={(e) => setCalendar(e.value)} />
                </div>
            </Dialog>
            <Dialog header={rejectHeader} footer={rejectFooter} visible={isOpenReject}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalReject}>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Fecha pago</label>
                    <Calendar id="navigators" value={settlementDate} onChange={(e) => setSettlementDate(e.value)} locale="es" dateFormat="dd-mm-yy" showIcon placeholder="Fecha pago" />
                </div>
                <div className='flex flex-column gap-1'>
                    <label htmlFor="label">Calendario</label>
                    <Dropdown filter showClear filterBy="DETAIL" optionLabel='DETAIL' placeholder="Calendario" value={calendar} options={calendarList} onChange={(e) => setCalendar(e.value)} />
                </div>
            </Dialog>
            <div className="flex flex-column align-items-center justify-content-center font-bold text-4xl mt-5">
                <span className="text-900">Novedades ocasionales marcación{window.location.href.indexOf('/HistoricOccasionalMarking') !== -1 && ' histórico'}</span>
            </div>
            {localStorage.getItem('tracking') === 'N'?
                <div className='flex justify-content-center'>
                    <Card style={{ width: "60%" }}>
                        <Message severity="info"
                        style={{
                            width: "100%",
                            fontSize: "18px",
                            border: 'solid #696cff',
                            borderWidth: '2px',
                            color: '#696cff'
                        }}
                        content={msgContent}
                        />
                    </Card>
                </div>:
                <div className="card mt-4 w-9">
                    <SkeletonTable load={loadPage}>
                        <Toolbar start={leftToolbarTemplate} end={rightToolbarTemplate} />
                        <Toolbar start={leftToolbarTemplate2} end={rightToolbarTemplate2} />
                        <DataTable className="text-xs" value={novelties} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
                            selection={occasionalSelected} onSelectionChange={(e) => {setOccasionalSelected(e.value); setOccasional(e.value)}} dataKey="OCCASIONAL_ID" selectionMode="multiple"
                            size="small" filters={filters1} filterDisplay="menu" header={header1} 
                            globalFilterFields={['OCCASIONAL_ID', 'CONTRACT_ID', 'CONTRACT', 'SHIFT_MARKING_ID', 'YEAR', 'WEEK', 'COST_CENTER', 'COST_CENTER_ID', 'STATUS_DESC', 'LOV_STATUS_DESC']}
                        >
                            <Column selectionMode="multiple" headerStyle={{ width: '3em' }}></Column>
                            <Column field="OCCASIONAL_ID" header="ID" filter filterMatchModeOptions={matchModes} filterPlaceholder="Buscar por ID" sortable></Column>
                            <Column field="SHIFT_MARKING_ID" header="ID marcación" filter filterMatchModeOptions={matchModes} filterPlaceholder="Buscar por ID marcación" sortable></Column>
                            <Column field="YEAR" header="Año" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Año" sortable></Column>
                            <Column field="WEEK" header="Semana"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Semana" sortable></Column>
                            <Column field="CONTRACT_ID" header="Contrato"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Contrato" sortable></Column>
                            <Column field="CONTRACT" header="Nombre"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
                            <Column field="CONCEPT_ID" header="Concepto"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Concepto" sortable></Column>
                            <Column field="CONCEPT" header="Nombre concepto"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre concepto" sortable></Column>
                            <Column field="UNIT" header="Unidad"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Unidad" sortable></Column>
                            <Column field="EVENT_DATE" header="Fecha evento"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha evento" sortable></Column>
                            <Column field="SETTLEMENT_DATE" header="Fecha pago" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha pago" sortable></Column>
                            <Column field="CALENDAR_ID" header="Calendario"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Calendario" sortable></Column>
                            <Column field="CALENDAR" header="Nombre calendario"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre calendario" sortable></Column>
                            <Column field="COMMENTS" header="Comentarios"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Comentarios" sortable></Column>
                            <Column field="STATUS_DESC" header="Estado"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Estado" sortable></Column>
                            <Column field="COST_CENTER" header="Centro de costo contable" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Centro de costo contable" sortable></Column>
                            <Column field="COST_CENTER_ID" header="Código centro de costo contable"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Código centro de costo contable" sortable></Column>
                            {window.location.href.indexOf('/OccasionalMarking') !== -1 && <Column header="Acciones" headerStyle={{ width: '4rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />}
                        </DataTable>
                    </SkeletonTable>
                </div>
                }
        </div>
    )
}

export default OccasionalMarking
